// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="cancelPaymentHeader" id="dialogTitle">Cancel Payment</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="cancelPaymentBody">Are you sure you want to cancel this payment
                for {{ data.paymentAmount | currency }}?</p>
        </div>
        <div class="hoa-dialog__footer hoa-dialog__footer--overflowX">
            <button tid="cancelPaymentNo" id="noButton" class="Button Button--link Button--minWidth130"
                    (click)="closeDialog(0)">No
            </button>
            <button tid="cancelPaymentYes" id="yesButton" class="Button Button--blue Button--minWidth130"
                    (click)="closeDialog('cancel')">Yes
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;